import { saveAs } from 'file-saver'

export function downloadCsv(
  filename: string,
  headers: string[],
  rows: Array<Array<string | number | null | undefined>>
) {
  const quote = (value: string | number | null | undefined) =>
    `"${String(value == null ? '' : value).replace(/"/g, '""')}"`

  const csv = [
    headers.map(quote).join(';'),
    ...rows.map(row => row.map(quote).join(';'))
  ].join('\n')

  saveAs(new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' }), filename)
}
